import { Component } from '@angular/core';
import { FormComponent } from './form/form.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  browserLang: string;
  middleWord: string;

  constructor( private formComponent: FormComponent, private translateService: TranslateService ) {  }
  title = 'online-reg-UI';

	getLang(): any {

		this.translateService.onLangChange.subscribe(lang => {
			this.browserLang = lang.lang;
			if (this.browserLang == "en") {
				this.middleWord = " to ";
				return this.middleWord;
			} else if (this.browserLang == "ms") {
				this.middleWord = " hingga ";
				return this.middleWord;
			}
		});

		if(this.browserLang == undefined) {
			if (this.translateService.defaultLang == "en") {
				this.middleWord = " to ";
				return this.middleWord;
			} else if (this.translateService.defaultLang == "ms") {
				this.middleWord = " hingga ";
				return this.middleWord;
			}
		}

		
  	}

  	showTime(category): string {
    	this.getLang();

		if (category == 'weekdays') {
			return this.formComponent.weekdaysTimeFrom + this.middleWord + this.formComponent.weekdaysTimeTo;
		} else {
			return this.formComponent.weekendTimeFrom + this.middleWord + this.formComponent.weekendTimeTo;
		}
		 
	}
 
}
